import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-table-row-detail-panel',
  template: '<ng-content />',
  styleUrls: ['table-row-detail-panel.component.scss']
})
export class TableRowDetailPanelComponent {
}
